<ng-select
  #branchSelect
  [fixNgSelectBottom]="branchSelect"
  data-cy="branchSelect"
  class="w-72 select-none text-base"
  (open)="openBranchSelect()"
  [loading]="branchesListLoading"
  [items]="branchesList"
  [clearable]="false"
  [searchable]="false"
  [disabled]="selectedProjectId === undefined || needSave === true"
  [(ngModel)]="selectedBranchExtraId"
  (change)="branchChange()"
  (keyup.esc)="$event.stopImmediatePropagation(); branchSelect.blur()"
  (keyup.enter)="$event.stopImmediatePropagation(); branchSelect.blur()"
  appendTo="body"
  placeholder="Repository - Branch"
  bindLabel="extraName"
  bindValue="extraId"
>
  <ng-template ng-label-tmp let-item="item">
    <div class="ml-1 truncate">{{ item.extraName }}</div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    <div class="ml-1 truncate">{{ item.extraName }}</div>
  </ng-template>

  <ng-template ng-footer-tmp>
    <div class="text-s400 cursor-default p-3" *ngIf="isEditor === false">
      FileEditor role is required to switch to Dev repo branches (Development
      mode)
    </div>

    <div
      class="text-s400 cursor-default p-3"
      *ngIf="isEditor === true && !!repo.repoId && repo.conflicts.length > 0"
    >
      Resolve conflicts to be able to switch, merge, delete or create Dev repo
      branches
    </div>

    <div
      class="text-s400 cursor-default p-3"
      *ngIf="
        isEditor === true &&
        !!repo.repoId &&
        repo.conflicts.length === 0 &&
        repo.repoStatus === repoStatusNeedCommit
      "
    >
      Commit changes to be able to switch, merge, delete or create Dev repo
      branches
    </div>

    <div
      *ngIf="
        isEditor === true &&
        !!repo.repoId &&
        repo.conflicts.length === 0 &&
        repo.repoStatus !== repoStatusNeedCommit
      "
      tp="Not available for Session repos"
      [tpIsEnabled]="selectedBranchItem.repoType === repoTypeEnum.Session"
    >
      <button
        data-cy="branchSelectCreateBranchButton"
        class="w-full rounded py-3 text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            selectedBranchItem.repoType === repoTypeEnum.Session,
          'text-m600 hover:bg-m50':
            selectedBranchItem.repoType !== repoTypeEnum.Session
        }"
        (click)="createNewBranch(branchSelect, $event)"
        [disabled]="selectedBranchItem.repoType === repoTypeEnum.Session"
        >New Branch</button
      >
    </div>

    <div
      *ngIf="
        isEditor === true &&
        !!repo.repoId &&
        repo.conflicts.length === 0 &&
        repo.repoStatus !== repoStatusNeedCommit
      "
      [tp]="
        selectedBranchItem.repoType === repoTypeEnum.Session
          ? 'Not available for Session repos'
          : 'Switch to a Dev branch to merge'
      "
      [tpIsEnabled]="selectedBranchItem.repoType !== repoTypeEnum.Dev"
    >
      <button
        data-cy="branchSelectMergeBranchButton"
        class="w-full rounded py-3 text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            selectedBranchItem.repoType !== repoTypeEnum.Dev,
          'text-m600 hover:bg-m50':
            selectedBranchItem.repoType === repoTypeEnum.Dev
        }"
        (click)="mergeBranch(branchSelect, $event)"
        [disabled]="selectedBranchItem.repoType !== repoTypeEnum.Dev"
        >Merge Branch</button
      >
    </div>

    <div
      *ngIf="
        isEditor === true &&
        (!repo.repoId ||
          (repo.conflicts.length === 0 &&
            repo.repoStatus !== repoStatusNeedCommit))
      "
      [tp]="
        selectedBranchItem.repoType === repoTypeEnum.Session
          ? 'Not available for Session repos'
          : 'Cannot delete the default branch'
      "
      [tpIsEnabled]="
        selectedBranchItem.branchId === defaultBranch ||
        selectedBranchItem.repoType === repoTypeEnum.Session
      "
    >
      <button
        data-cy="branchSelectDeleteBranchButton"
        class="w-full rounded py-3 text-base focus:outline-none"
        [ngClass]="{
          'text-s400 cursor-default':
            selectedBranchItem.branchId === defaultBranch ||
            selectedBranchItem.repoType === repoTypeEnum.Session,
          'text-m600 hover:bg-m50':
            selectedBranchItem.branchId !== defaultBranch &&
            selectedBranchItem.repoType !== repoTypeEnum.Session
        }"
        (click)="deleteBranch(branchSelect, $event)"
        [disabled]="
          selectedBranchItem.branchId === defaultBranch ||
          selectedBranchItem.repoType === repoTypeEnum.Session
        "
        >Delete Branch</button
      >
    </div>

    <!-- <div
      class="cursor-default p-3 text-s400"
      *ngIf="
        isEditor === true &&
        (!repo.repoId ||
          (repo.conflicts.length === 0 &&
            repo.repoStatus !== repoStatusNeedCommit &&
            repo.repoId === prodRepoID))
      "
    >
      Switch to the Dev repo to be able to merge dev branches
    </div> -->
  </ng-template>
</ng-select>

<div *ngIf="repo$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="isEditor$ | async"></div>
<div *ngIf="file$ | async"></div>
<div *ngIf="needSave$ | async"></div>
<div *ngIf="routerEvents$ | async"></div>
